import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isFloorMapDeviceKey, isValidFloorMapCustomDevicePreference } from '@/components/_dashboard/booking/floormap/floormapDevices';
import type { FloorMapCustomDevicePreference, FloorMapDevicePreference } from '@/@type/floormap';

interface SetFloorMapDevicePreferencePayload {
    merchantId: string;
    deviceKey: string;
    customDevice?: FloorMapCustomDevicePreference;
    updatedAt: string;
}

type SetFloorMapDevicePreferenceInput = Omit<SetFloorMapDevicePreferencePayload, 'updatedAt'> & {
    updatedAt?: string;
};

interface FloormapState {
    devicePreferencesByMerchant: Record<string, FloorMapDevicePreference>;
}

const initialState: FloormapState = {
    devicePreferencesByMerchant: {}
};

const slice = createSlice({
    name: 'floormap',
    initialState,
    reducers: {
        setFloorMapDevicePreference: {
            reducer(state, action: PayloadAction<SetFloorMapDevicePreferencePayload>) {
                const { merchantId, deviceKey, customDevice, updatedAt } = action.payload;
                if (!merchantId || !isFloorMapDeviceKey(deviceKey)) return;
                if (deviceKey === 'custom' && (!customDevice || !isValidFloorMapCustomDevicePreference(customDevice))) return;

                state.devicePreferencesByMerchant[merchantId] = {
                    deviceKey,
                    customDevice: deviceKey === 'custom' ? customDevice : undefined,
                    updatedAt
                };
            },
            prepare(payload: SetFloorMapDevicePreferenceInput) {
                return {
                    payload: {
                        ...payload,
                        updatedAt: payload.updatedAt ?? new Date().toISOString()
                    }
                };
            }
        }
    }
});

export default slice.reducer;
export const { setFloorMapDevicePreference } = slice.actions;
